<template lang="pug">
  .sidebar(:class="{ open: openSidebar }")
    .search
      .search-menu
        .search-title
          span 絞り込む
        .search-row
          span.search-label
            | 企業名
          label.text
            input(
              type="text"
              v-model="corporateName"
              placeholder="例）株式会社XXXX"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row
          span.search-label
            | 出稿メディア履歴
          select(v-model="publishedRecruitMediaTerm")
            option(v-for="option in publishedRecruitMediaTerms" :value="option.code")
              | {{ option.name }}
          MultipleSelect(v-model="publishedRecruitMediaCd" :options="vSelectMedia")
        .search-row
          span.search-label
            | 出稿予算
          select(v-model="budgetTerm")
            option(v-for="option in budgetTerms" :value="option.code") {{ option.name }}
          label
            select.select-short(v-model="budgetLower")
              option(v-for="option in budgetValues" :value="option.code")
                | {{ option.name }}
            span 〜
          label
            select.select-short(v-model="budgetUpper")
              option(v-for="option in budgetValues" :value="option.code")
                | {{ option.name }}
        .search-row
          span.search-label
            | 掲載状況
          label.radio
            input(type='radio' v-model="published" value="1")
            span 出稿履歴あり
          label.radio
            input(type='radio' v-model="published" value="2")
            span 直近1年間出稿履歴無し
          br
          label.radio
            input(type='radio' v-model="publishedRecruitOrAp" value="0")
            span すべて
          label.radio
            input(type='radio' v-model="publishedRecruitOrAp" value="1")
            span 中途のみ
          label.radio
            input(type='radio' v-model="publishedRecruitOrAp" value="2")
            span APのみ
          select(v-model="publishedTerm")
            option(v-for="option in publishedTerms" :value="option.code")
              | {{ option.name }}
        .search-row
          span.search-label 本社・所在地
          .select-tree(:class="{ active: openPrefectureCityModal }")
            a.select-tree-button(
              @click="toggleCompanyCityModal"
              :class="{ active: openPrefectureCityModal }")
              | 選択する
            span.select-tree-selected(v-if="cityCd.length > 0") 選択中
            PrefectureCityModal(
              :prefectures="this.$store.state.master.prefectures.filter(v=> v.code !== 99)"
              :openPrefectureCityModal="openPrefectureCityModal"
              :selectedCityCd="cityCd"
              @setPrefectureCities="setCityCd"
              @hide="hidePrefectureCityModal")
        .search-row
          span.search-label
            | 業種
          MultipleSelect(v-model="industryCd" :options="vSelectIndustry")
        .search-row
          span.search-label
            | 設立
          select(v-model="establishedYear")
            option(v-for="option in establishedYears" :value="option.code") {{ option.name }}
        .search-row
          span.search-label
            | 特徴
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd60" value="60")
            span 人材紹介・エージェントを省く
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd62" value="62")
            span 派遣会社を省く
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd61" value="61")
            span RPOを省く
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCorporateTel"
              true-value="true"
              false-value="false")
            span 電話番号なしを省く
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCorporateUrl"
              true-value="true"
              false-value="false")
            span 企業URLなしを省く
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd40" value="40")
            span 上場企業・株式公開企業
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd41" value="41")
            span 高成長企業
          label.checkbox
            input(type='checkbox' v-model="prPointCd" id="prPointCd42" value="42")
            span 外資系企業
        .search-row
          span.search-label
            | キーワード（事業内容など）
          label.text
            input(
              type="text"
              v-model="keyword"
              placeholder="例）事業内容など"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
      .search-button
        input.button-main(
          type="button"
          @click="search"
          value="検索する"
          :disabled="locked")
        span
          a(@click="clear") クリア
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import {
    updatedDates,
    establishedYears,
    publishedRecruitMediaTerms,
    publishedTerms,
    budgetTerms,
    budgetValues,
    DefaultUpdatedDateCode,
    DefaultBudgetTerm,
    DefaultEstablishedYear,
    DefaultPublished,
    DefaultPublishedRecruitMediaTerm,
    DefaultPublishedRecruitOrAp,
    DefaultPublishedTerm,
    DefaultSearchCorporationQuery,
    DefaultExcludedNoCompanyTel,
    DefaultExcludedNoCompanyUrl,
  } from '../../constants'
  import { api } from '../../libs/api'
  import mapGetSet from '../../libs/map-get-set'
  import searchCorporation from '../../store/modules/searchCorporation'
  import MultipleSelect from '../parts/MultipleSelect'
  import PrefectureCityModal from '../parts/PrefectureCityModal'

  export default {
    components: { MultipleSelect, PrefectureCityModal },
    props: ['openSidebar'],
    beforeCreate () {
      this.updatedDates = updatedDates
      this.establishedYears = establishedYears
      this.publishedRecruitMediaTerms = publishedRecruitMediaTerms
      this.publishedTerms = publishedTerms
      this.budgetTerms = budgetTerms
      this.budgetValues = budgetValues
    },
    data () {
      const {
        updatedDate = DefaultUpdatedDateCode,
        budgetLower = '',
        budgetUpper = '',
        budgetTerm = DefaultBudgetTerm,
        corporateName = '',
        cityCd = '',
        establishedYear = DefaultEstablishedYear,
        industryCd = '',
        keyword = '',
        prPointCd = '',
        published = DefaultPublished,
        publishedRecruitMediaCd = '',
        publishedRecruitMediaTerm = DefaultPublishedRecruitMediaTerm,
        publishedTerm = DefaultPublishedTerm,
        publishedRecruitOrAp = DefaultPublishedRecruitOrAp,
        excludedNoCorporateTel = DefaultExcludedNoCompanyTel,
        excludedNoCorporateUrl = DefaultExcludedNoCompanyUrl,
        stationId = '',
      } = this.$route.query

      // query parameter initialization
      const master = this.$store.state.master
      this.updatedDate = updatedDate
      this.budgetLower = budgetLower
      this.budgetUpper = budgetUpper
      this.budgetTerm = budgetTerm
      this.corporateName = corporateName
      this.cityCd = this.toObjects(cityCd, master.cities)
      this.establishedYear = establishedYear
      this.industryCd = this.toObjects(industryCd, master.industries)
      this.keyword = keyword
      this.prPointCd = this.toArray(prPointCd)
      this.published = published
      this.publishedRecruitMediaCd = this.toObjects(publishedRecruitMediaCd, master.mediaForJobs)
      this.publishedTerm = publishedTerm
      this.publishedRecruitMediaTerm = publishedRecruitMediaTerm
      this.publishedRecruitOrAp = publishedRecruitOrAp
      this.stationId = stationId
      this.excludedNoCorporateTel = excludedNoCorporateTel
      this.excludedNoCorporateUrl = excludedNoCorporateUrl

      if (this.$route.query.stationId) {
        api.fetchStation({ id: this.$route.query.stationId })
          .then((res) => {
            if (res) {
              this.stationName = res[0].name
            }
          })
      } else {
        this.stationName = ''
      }

      return {
        filteredStations: [],
        timeoutId: null,
        keyDownCode: '',
        openPrefectureCityModal: false,
      }
    },
    computed: {
      ...mapGetters({
        apiQuery: 'searchCorporation/apiQuery',
        locked: 'common/isGlobalLocked',
      }),
      vSelectIndustry () {
        return this.$store.state.master.industries.map(i => ({ label: i.name, value: i.code }))
      },
      vSelectMedia () {
        return this.$store.state.master.mediaForJobs.map(m => ({ label: m.name, value: m.code }))
      },
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchCorporation.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchCorporation/${k}`, v),
        keys: Object.keys(searchCorporation.state.query),
      }),
    },
    watch: {
      $route () {
        Object.assign(this.$data, this.$options.data.apply(this))
      },
    },
    methods: {
      ...mapMutations('company', ['uncheckAll']),
      clear () {
        const { name } = this.$route
        this.uncheckAll()
        this.$emit('toggleSidebar')
        const query = {
          ...DefaultSearchCorporationQuery,
          perPage: String(this.$store.state.user.detail.corporations_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        this.$router.push({ name, query })
      },
      hidePrefectureCityModal () {
        this.openPrefectureCityModal = false
      },
      async keydownCondition (e) {
        this.keyDownCode = e.which
      },
      async keyupCondition (e) {
        // Enter押下時に検索する。keyDownCode持ってるのは日本語変換のEnterを無視するため
        if (e.which === 13 && e.which === this.keyDownCode) {
          this.search()
        }
      },
      async search () {
        const { name, query } = this.$route
        this.$store.commit('common/lockGlobal')
        this.uncheckAll()
        try {
          this.$router.push({
            name,
            query: {
              ...this.apiQuery,
              perPage: query.perPage,
              page: '1',
              _t: Date.now(),
            },
          })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
      },
      async setCityCd (cityCd) {
        this.openPrefectureCityModal = false
        this.cityCd = cityCd
      },
      toArray (ids) {
        if (!ids) {
          return []
        }
        return ids.split(',')
      },
      toObjects (ids, masterData) {
        if (!ids) {
          return []
        }

        const isNumber = typeof masterData[0].code === 'number'
        return ids.split(',').map((id) => {
          const data = isNumber ?
            masterData.find(d => d.code === Number(id)) :
            masterData.find(d => d.code === id)
          return { label: data.name, value: data.code }
        })
      },
      toggleCompanyCityModal (e) {
        e.stopPropagation()
        this.openPrefectureCityModal = !this.openPrefectureCityModal
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CorporationSidebar.vue